import { get, set } from "lodash";
import { thor } from "../../../typings/thor";
import { Enums } from "../../../thor.enums";

export class NewItemDialogController {
    public static $inject: string[] = [
        "$mdDialog",
        "$mdMedia",
        "$scope",
        "$translate",
        "categoryService",
        "localeNumber",
        "utilsService",
        "toaster"
    ];

    public categories: any;
    public fields: any[];
    public itemNewForm;
    public item: any;
    public saving;
    public saleCurrencySymbol: Enums.Currency;

    private sale: any; // bind from parent (AddItemController::createNewItemDialog)

    constructor(
        private $mdDialog: ng.material.IDialogService,
        public $mdMedia: ng.material.IMedia,
        private $scope: ng.IScope,
        private $translate: ng.translate.ITranslateService,
        categoryService,
        private localeNumber,
        private utilsService,
        private toaster
    ) {
        this.fields = categoryService.getFields();
        this.categories = categoryService.getCategories();

        this.saving = false;
    }

    public $onInit() {
        this.saleCurrencySymbol = this.localeNumber.getCurrencySymbol(this.sale.resource.currency);
        this.item = {
            field: this.sale.resource.field,
            category_id: this.sale.resource.category_id
        };
        this.$scope.$watch(
            () => [this.item.orderNumberPrimary, this.item.orderNumberSecondary],
            current => {
                if (current[0]) {
                    const sameItemFound = this.utilsService.findItemByOrderNumber(
                        {
                            primary: this.item.orderNumberPrimary || null,
                            secondary: this.item.orderNumberSecondary || null
                        },
                        this.sale.items
                    );
                    this.itemNewForm.orderNumberPrimary.$setValidity("uniqueOrderNumber", !sameItemFound);
                } else {
                    this.itemNewForm.orderNumberPrimary.$setValidity("uniqueOrderNumber", true);
                }
            },
            true
        );
    }

    public create() {
        if (this.saving || this.itemNewForm.$invalid) {
            return;
        }

        this.saving = true;

        const itemPost: thor.ItemPost = {
            meta: {},
            category_id: this.item.category_id
        };

        if (this.item.description) {
            itemPost.description = this.item.description.toString();
        }

        if (this.item.orderNumberPrimary) {
            const orderNumber = {};
            set(orderNumber, "primary", parseInt(this.item.orderNumberPrimary, 10));

            if (this.item.orderNumberSecondary) {
                set(orderNumber, "secondary", this.item.orderNumberSecondary.toString());
            }
            itemPost.meta.order_number = orderNumber;
        }

        if (this.item.estimateMin || this.item.estimateMax) {
            const pricing = {};
            set(pricing, "estimates.min", this.item.estimateMin);
            set(pricing, "estimates.max", this.item.estimateMax);
            itemPost.pricing = pricing;
        }

        this.sale.createItem(itemPost)
            .then(item => {
                this.sale.insertItem(item);
                this.$mdDialog.hide();
            })
            .catch(() => {
                this.toaster.toast({
                    message: this.$translate.instant("une_erreur_est_survenue_creation_impossible")
                });
            })
            .finally(() => {
                this.saving = false;
            });
    }

    public cancel() {
        this.$mdDialog.cancel();
    }

    public checkEstimateValidity() {
        const min = get(this.item, "estimateMin");
        const max = get(this.item, "estimateMax");
        this.itemNewForm.estimateMax.$setValidity("estimateValue", !min || !max || min <= max);
    }
}
